export function handleQuery(query) {
    return Object
    .entries(query)
    .map(([key, value], i) => Array.isArray(value) ? `${key}=${value.join('&' + key + '=')}` : value !== undefined && value !== null ? `${key}=${value}` : null)
    .filter(q => q)
    .join('&');
}